<p class="px-3">{{ 'payment.address.description' | translate }}</p>

<form
  class="top-up-address"
  *ngIf="topUpAddressForm"
  [formGroup]="topUpAddressForm"
  (ngSubmit)="save(topUpAddressForm.value, topUpAddressForm.valid)"
>
  <div class="px-3">
    <div class="row g-4">
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showFirstName">
        <div class="form-floating">
          <input
            type="text"
            formControlName="firstName"
            id="firstName"
            class="form-control"
            [class.is-invalid]="f.firstName.invalid"
          />
          <label for="firstName">{{ 'address.firstname.label' | translate }}</label>
          <div *ngIf="submitted && f.firstName.errors" class="alert alert-danger">
            <div *ngIf="f.firstName.errors.required">{{ 'address.missing.firstname' | translate }}</div>
            <div *ngIf="f.firstName.errors.empty">{{ 'address.empty.firstname' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showLastName">
        <div class="form-floating">
          <input type="text" formControlName="surname" id="surname" class="form-control" [class.is-invalid]="f.surname.invalid" />
          <label for="surname">{{ 'address.surname.label' | translate }}</label>
          <div *ngIf="submitted && f.surname.errors" class="alert alert-danger">
            <div *ngIf="f.surname.errors.required">{{ 'address.missing.surname' | translate }}</div>
            <div *ngIf="f.surname.errors.empty">{{ 'address.empty.surname' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showAddressName">
        <div class="form-floating">
          <input
            type="text"
            formControlName="addressName"
            id="addressName"
            class="form-control"
            [class.is-invalid]="f.addressName.invalid"
          />
          <label for="addressName">{{ 'address.name.label' | translate }}</label>
          <div *ngIf="submitted && f.addressName.errors" class="alert alert-danger">
            <div *ngIf="f.addressName.errors.required">{{ 'address.missing.addressName' | translate }}</div>
            <div *ngIf="f.addressName.errors.empty">{{ 'address.empty.addressName' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showStreet">
        <div class="form-floating">
          <input type="text" formControlName="street" id="street" class="form-control" [class.is-invalid]="f.street.invalid" />
          <label for="street">{{ 'address.street.label' | translate }}</label>
          <div *ngIf="submitted && f.street.errors" class="alert alert-danger">
            <div *ngIf="f.street.errors.required">{{ 'address.missing.street' | translate }}</div>
            <div *ngIf="f.street.errors.empty">{{ 'address.empty.street' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showTown">
        <div class="form-floating">
          <input type="text" formControlName="town" id="town" class="form-control" [class.is-invalid]="f.town.invalid" />
          <label for="town">{{ 'address.city.label' | translate }}</label>
          <div *ngIf="submitted && f.town.errors" class="alert alert-danger">
            <div *ngIf="f.town.errors.required">{{ 'address.missing.city' | translate }}</div>
            <div *ngIf="f.town.errors.empty">{{ 'address.empty.city' | translate }}</div>
          </div>
        </div>
      </div>
      <fgbcl-country-and-regions
        style="padding: 0 11px"
        *ngIf="topUpAddressConfig.showCountryRegion"
        [Form]="topUpAddressForm"
        [HasSubmitted]="submitted"
      >
      </fgbcl-country-and-regions>
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showPostCode">
        <div class="form-floating">
          <input
            type="text"
            formControlName="postCode"
            id="postCode"
            class="form-control"
            [class.is-invalid]="f.postCode.invalid"
          />
          <label for="postCode">{{ 'address.postcode.label' | translate }}</label>
          <div *ngIf="submitted && f.postCode.errors" class="alert alert-danger">
            <div *ngIf="f.postCode.errors.required">{{ 'address.missing.postcode' | translate }}</div>
            <div *ngIf="f.postCode.errors.pattern">{{ 'address.invalid.postcode' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12" *ngIf="topUpAddressConfig.showMobileNumber">
        <div class="form-floating">
          <input
            type="text"
            formControlName="homeNumber"
            id="mobileNumber"
            class="form-control"
            [class.is-invalid]="f.homeNumber.invalid"
          />
          <label for="homeNumber">{{ 'address.number.label' | translate }}</label>
          <div *ngIf="submitted && f.homeNumber.errors" class="alert alert-danger">
            <div *ngIf="f.homeNumber.errors.required">{{ 'address.missing.number' | translate }}</div>
            <div *ngIf="f.homeNumber.errors.pattern">{{ 'address.invalid.number' | translate }}</div>
          </div>
        </div>
      </div>
      <div class="col-12" *ngIf="topUpAddressConfig.showEmail">
        <div class="form-floating">
          <input
            type="text"
            formControlName="emailAddress"
            id="emailAddress"
            class="form-control"
            [class.is-invalid]="f.emailAddress.invalid"
          />
          <label for="emailAddress">{{ 'address.email.label' | translate }}</label>
          <div *ngIf="submitted && f.emailAddress.errors" class="alert alert-danger">
            <div *ngIf="f.emailAddress.errors.required">{{ 'address.missing.email' | translate }}</div>
            <div *ngIf="f.emailAddress.errors.pattern">{{ 'address.invalid.email' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btn-container justify-content-end">
    <button type="button" class="btn fw-bold text-danger" id="cancelButton" (click)="cancel()">
      {{ 'address.cancel.label' | translate }}
    </button>
    <button type="submit" class="btn btn-success text-white fw-bold" id="saveButton">
      {{ 'address.confirm.label' | translate }}
    </button>
  </div>
</form>
